import { useEffect, useState } from 'react';
import { connect } from 'redux-bundler-react';

import FileInput from '@components/file-input/FileInput';

import { useFormContext } from 'react-hook-form';

import { FileTypes } from '@src/utils/enums';
import { QUESTION_TYPE } from '../dynamic-form.validation';
import { useRequest } from '@stores';

const DynamicFileInput = connect(
  'doDeleteFile',
  'doDownloadFile',
  'doResetFilesByQuestionId',
  'doUpdateSelectedFiles',
  'selectJpaFiles',
  'selectRequestFormData',
  'selectCombinedComponentFiles',
  ({
    doDeleteFile,
    doDownloadFile,
    doResetFilesByQuestionId,
    doUpdateSelectedFiles,
    requestFormData,
    combinedComponentFiles,
    componentID,
    fileDownload,
    formId,
    name,
    label,
    tooltip,
    questionData,
  }) => {
    const { questionId, sectionId, isRequired } = questionData;
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileErrors, setFileErrors] = useState(false);
    const isSelectedFiles = selectedFiles?.length > 0;
    const requestType = requestFormData?.request?.requestType;

    const questionFiles = combinedComponentFiles.filter(
      (item) => Number(item.sectionID) === Number(sectionId) && Number(item.questionID) === Number(questionId)
    );
    const isS3File = questionFiles.filter((item) => item?.isUploadedToS3).length > 0;

    const isReadOnly = useRequest((state) => state.isFormReadOnly);
    const { setValue, trigger, watch } = useFormContext();

    const handleFileInput = (e) => {
      //Only continue if a file has been selected
      if (e.target.files && e.target.files.length > 0) {
        const filesArr = Array.from(e?.target?.files) ?? [];
        setSelectedFiles(filesArr);
        trigger(name);
      }
    };

    const handleDeleteFile = () => {
      isS3File && questionFiles.forEach((item) => doDeleteFile(item.fileName, componentID));
      doResetFilesByQuestionId(questionId);
      setSelectedFiles([]);
      // Update RHF values object
      setValue(name, [], { shouldValidate: true });
    };

    // Download file(s) from S3
    const handleDownloadFile = () => {
      isS3File && questionFiles.forEach((item) => doDownloadFile(item.fileName, FileTypes.Request));
    };

    // Update Redux Store files list with staged files
    useEffect(() => {
      if (isSelectedFiles) {
        const doSelectFile = () => {
          selectedFiles.forEach((item) => {
            const fileTags = {
              componentID: componentID,
              file: item,
              fileName: item?.name,
              isInvalid: fileErrors === true,
              questionID: questionId,
              sectionID: sectionId,
              questionTypeID: QUESTION_TYPE.file,
              section: requestType,
            };
            doUpdateSelectedFiles(fileTags);
          });
        };

        doResetFilesByQuestionId(questionId);
        doSelectFile();
      }
    }, [
      doResetFilesByQuestionId,
      doUpdateSelectedFiles,
      componentID,
      questionId,
      sectionId,
      requestType,
      fileErrors,
      isSelectedFiles,
      formId,
      selectedFiles,
    ]);

    useEffect(() => {
      if (fileErrors) {
        setValue(name, [], { shouldValidate: true });
        trigger(name);
      }
    }, [fileErrors, name, setValue, trigger]);

    // EDGE CASE: Retrieving S3 files and syncing hasJPAFileUploaded value
    // User deleted files but did not save request
    useEffect(() => {
      if (questionFiles.length === 0 && watch(name) === true) {
        setValue(name, false, { shouldValidate: true });
      }
      if (questionFiles.length > 0 && watch(name) !== true && isS3File) {
        setValue(name, true, { shouldValidate: true });
      }
    }, [isS3File, name, formId, questionFiles, setValue, watch]);

    return (
      <FileInput
        downloadFileCallback={() => handleDownloadFile()}
        deleteFileCallback={() => handleDeleteFile()}
        fileDownload={fileDownload}
        id={name}
        label={label}
        multiple={true}
        name={name}
        onChangeCallback={handleFileInput}
        readOnly={isReadOnly}
        required={isRequired}
        resetFileErrors={!fileErrors}
        setFileErrors={setFileErrors}
        showDownloadButton={isS3File}
        tooltip={tooltip}
        value={questionFiles}
      />
    );
  }
);

export default DynamicFileInput;
